import { SITE_URL } from "@/lib/seo-schemas";

export const thumb = (src) =>
  src && src.startsWith("/projects/") && src.endsWith(".webp") && !src.endsWith("-sm.webp")
    ? src.replace(/\.webp$/, "-sm.webp")
    : src;

export const absUrl = (src) => (!src ? `${SITE_URL}/logo512.png` : src.startsWith("http") ? src : `${SITE_URL}${src}`);
